module.exports = __webpack_public_path__ + "static/logo-platform-a869a78392ba2a1a8dc03ac9b848689f.png";